import React, { Component } from "react";

import { 
  Navbar, 
  NavbarBrand,
  Nav,
  Button
} from "reactstrap";

import { 
  Container, 
  Row, 
  Col 
} from "react-grid-system";

import axios from 'axios';

import GenericPanel from './GenericPanel.js';
import InputData from './InputData.js';
import Settings from './Settings.js';
import JobDetails from './JobDetails.js';

import './index.css';
import * as Constants from "./Constants.js";

class Portal extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      submitPending : false,
      overlayContent : Constants.epilogosMemeJobSubmitInProgressMessage,
      overlayStatus: "",
      destinationURL: "",
      jobDetailsKey : 0,
      jobDesignerOverlayOKButtonStyle: { "visibility": "hidden" },
      jobDesignerOverlayContentSpinnerStyle: { "width": "22px", "height": "22px" },
      jobDesignerOverlayContentSpinnerSrc: "assets/img/spinner.svg",
      jobDesignerOverlayContentStyle: { "height": "110px" },
      genome : Constants.epilogosMemeDefaultGenome,
      stateModel : Constants.epilogosMemeDefaultStateModel[Constants.epilogosMemeDefaultGenome],
      sample : Constants.epilogosMemeDefaultSample,
      siteDistribution : Constants.epilogosMemeDefaultMotifSiteDistribution,
      background : Constants.epilogosMemeDefaultBackground,
      prior : Constants.epilogosMemeDefaultPrior,
      maxSize : Constants.epilogosMemeDefaultMaxSize,
      motifNumber : Constants.epilogosMemeDefaultMotifNumber,
      motifMinimumWidth : Constants.epilogosMemeDefaultMotifMinimumWidth,
      motifMaximumWidth : Constants.epilogosMemeDefaultMotifMaximumWidth,
      memeVersion : Constants.epilogosMemeDefaultMemeVersion,
      hideshow : {
        advancedOptions : true
      }
    };  
    this.updateDesign = this.updateDesign.bind(this);
    this.showOverlay = this.showOverlay.bind(this);
    this.hideOverlay = this.hideOverlay.bind(this);
    this.endSubmitPending = this.endSubmitPending.bind(this);
    this.updateOverlayContent = this.updateOverlayContent.bind(this);
    this.handleClick = this.handleClick.bind(this);
    
    this.jobDesignerOverlay = React.createRef();
    this.jobDesignerOverlayContent = React.createRef();
    this.jobDesignerOverlayContentSpinner = React.createRef();
    this.jobDesignerOverlayContentMessage = React.createRef();
    this.jobDesignerOverlayOKButton = React.createRef();
  }
  
  updateDesign = (design) => {
    let self = this;
    this.setState(design, () => { 
      // submit job, if state is pending, and lock up the UI in the meantime
      if (self.state.submitPending) {
        self.showOverlay();
        console.log("self.state to POST", self.state);
        axios.post('/assets/services/submitJob.py', { state : self.state })
        .then(function(response) {
          var data = response.data;
          var id = data.msg;
          self.updateOverlayContent(Constants.epilogosMemeJobSubmitState.SUCCESS, id);
        })
        .catch(function(error) {
          console.log(error);
          self.updateOverlayContent(Constants.epilogosMemeJobSubmitState.FAILED, (error.msg) ? error.msg : "500 server error — contact: " + Constants.epilogosMemeEmailContact);
        });
      }
    });
  }
  
  updateDesignForExampleBED = () => {
    //console.log("updateDesignForExampleBED");
    //console.log("this.state", this.state);
    let newState = {...this.state};
    newState.genome = "hg19";
    newState.siteDistribution = "zoops";
    newState.motifNumber = 3;
    newState.motifMinimumWidth = 12;
    newState.motifMaximumWidth = 12;
    newState.sample = "E123";
    //console.log("newState", newState);
    this.setState(newState, () => { /* console.log("this.state", this.state); */ this.setState({ jobDetailsKey : this.state.jobDetailsKey + 1 })});
  }
  
  endSubmitPending = () => {
    this.setState({ 
      submitPending : false,
      jobDetailsKey : this.state.jobDetailsKey+1
    }, () => { 
      this.updateOverlayContent(Constants.epilogosMemeJobSubmitState.PENDING);
      this.hideOverlay();
      console.log("post-endSubmitPending() state", this.state);
    });
  }
  
  updateOverlayContent = (type, msg) => {
    let html = null;
    let newJobDesignerOverlayOKButtonStyle = null;
    let newJobDesignerOverlayContentSpinnerStyle = null;
    let newJobDesignerOverlayContentSpinnerSrc = null;
    let newJobDesignerOverlayContentStyle = null;
    switch (type) {
      case Constants.epilogosMemeJobSubmitState.SUCCESS:
        newJobDesignerOverlayOKButtonStyle = { "visibility": "visible" };
        newJobDesignerOverlayContentSpinnerStyle = { "width": "22px", "height": "22px" }
        newJobDesignerOverlayContentSpinnerSrc = "assets/img/success.svg";
        newJobDesignerOverlayContentStyle = { "height": "270px" };
        html = Constants.epilogosMemeJobSubmitSuccessfulMessage + "<p/><p>Results will be available from: <a target=\"_blank\" href=\"" + Constants.rootURL + "/view/?id=" + msg + "\">" + Constants.rootURL + "/view/?id=" + msg + "</a></p>";
        break;
      case Constants.epilogosMemeJobSubmitState.FAILED:
        newJobDesignerOverlayOKButtonStyle = { "visibility": "visible" };
        newJobDesignerOverlayContentSpinnerStyle = { "width": "22px", "height": "22px" }
        newJobDesignerOverlayContentSpinnerSrc = "assets/img/caution.svg";
        newJobDesignerOverlayContentStyle = { "height": "160px" };
        html = Constants.epilogosMemeJobSubmitFailedMessage + "<div>" + msg + "</div>";
        break;
      case Constants.epilogosMemeJobSubmitState.PENDING:
      default:
        newJobDesignerOverlayOKButtonStyle = { "visibility": "hidden" };
        newJobDesignerOverlayContentSpinnerStyle = { "width": "22px", "height": "22px" }
        newJobDesignerOverlayContentSpinnerSrc = "assets/img/spinner.svg";
        newJobDesignerOverlayContentStyle = { "height": "110px" };
        html = Constants.epilogosMemeJobSubmitInProgressMessage;
        break;
    }
    this.setState({ 
      jobDesignerOverlayOKButtonStyle: newJobDesignerOverlayOKButtonStyle,
      jobDesignerOverlayContentSpinnerStyle: newJobDesignerOverlayContentSpinnerStyle,
      jobDesignerOverlayContentSpinnerSrc: newJobDesignerOverlayContentSpinnerSrc,
      jobDesignerOverlayContentStyle: newJobDesignerOverlayContentStyle,
      overlayContent : html,
      overlayStatus: type,
      destinationURL: `${Constants.rootURL}/view/?id=${msg}`
    });
  }

  showOverlay = () => {
    this.jobDesignerOverlay.style.display = 'block';
  }
  
  hideOverlay = () => {
    this.jobDesignerOverlay.style.display = 'none';
  }
  
  handleClick = (event) => {
    if ((event.target.name === 'closeOverlay') && (this.state.overlayStatus === Constants.epilogosMemeJobSubmitState.FAILED)) {
      this.endSubmitPending();
    }
    else if ((event.target.name === 'closeOverlay') && (this.state.overlayStatus === Constants.epilogosMemeJobSubmitState.SUCCESS)) {
      if (this.state.destinationURL && this.state.destinationURL.length > 0) {
        console.log("this.state.destinationURL", this.state.destinationURL);
        window.location.replace(this.state.destinationURL);
      }
      else {
        this.endSubmitPending();  
      }
    }
    document.activeElement.blur();
  }
  
  onClick = (event) => { 
    if (event.currentTarget.dataset.id) {
      event.preventDefault();
      let target = event.currentTarget.dataset.target || "_blank";
      window.open(event.currentTarget.dataset.id, target);
    }
  }
  
  stripQueryStringAndHashFromPath = (url) => { return url.split("?")[0].split("#")[0]; }
  
  render() { 
    return (
      <div className="App">
        <div className="parent-container">
          
          <Navbar color="#000000" fixed="true" expand="md" style={{backgroundColor:"#000000", cursor:"default", position:"fixed", overflow:"hidden", width:"100%", top:"0px", zIndex:"100"}}>
            <NavbarBrand className="mr-auto brand-content-portal">
              <div className="brand-content-header-portal brand-content-text-portal" onClick={(e)=>{this.onClick(e)}} data-id={Constants.epilogosMemeURL} data-target="_self">
                epilogos Search
              </div>
            </NavbarBrand>
          </Navbar>
          
          <div className="site-content">
          
            <div className="zrow">
              <div className="zcolumn zleft">
                <div className="panels" style={{"padding":"20px", "backgroundColor":"#efefef", "marginBottom":"40px", "minHeight":"calc(100vh - 110px)"}}>

                  <GenericPanel title="Design overview">
                    <img style={{textAlign:"left", width:"calc(100% - 30px)", marginTop:"10px", marginBottom:"20px", border:"1px lightgrey solid"}} src="assets/img/meme_thumbnail_v5.png" />
                    <p className="panel-label-notice"><a href="view/?id=50821ccf-4d5a-4cf9-9d3e-1f00caa46473" target="_blank">Example report (human)</a></p>
                    <p className="panel-label-notice">Genomic regions that share a certain type of functionality are often marked by similar chromatin/epigenomic marks — for instance, gene promoters. Given a set of genomic coordinates for such regions of interest, as well as the cell type of interest, the <strong>epilogos Search</strong> tool attempts to discover recurring local patterns/prototypes in these regions.</p>
                  </GenericPanel>
                  
                  <GenericPanel title="Input">
                    <InputData 
                      updateDesign={this.updateDesign} 
                      currentGenome={this.state.genome} 
                      currentStateModel={this.state.stateModel}
                      updateDesignForExampleBED={this.updateDesignForExampleBED} />
                  </GenericPanel>
                  
                  <GenericPanel title="Settings">
                    <Settings 
                      updateDesign={this.updateDesign}
                      currentDesign={this.state} />
                  </GenericPanel>
                
                </div>
              </div>
              <div className="zcolumn zright">
                <div className="panel-heading">
                  <div className="panel-title">Submit request</div>
                </div>
                <JobDetails 
                  key={this.state.jobDetailsKey}
                  updateDesign={this.updateDesign} 
                  currentDesign={this.state} />
              </div>
              
            </div>
            
            
            
          </div>
          
          <Navbar color="#000000" fixed="true" expand="md" style={{minHeight:"80px", position:"fixed", overflow:"hidden", width:"100%", bottom:"0px", backgroundColor:"#000000", cursor:"default"}}>
            <Nav>
            
              <Container fluid style={{"padding":0}}>
              
                <Row nogutter className="epilogos-offscreen-content-contact-row" style={{"color":"rgba(255, 255, 255, 1)", "backgroundColor":"rgba(0, 0, 0, 1)"}}>
                  <Col sm={6} className="epilogos-offscreen-content-row-text-block epilogos-offscreen-content-row-text-block-contact">
                    <div className="epilogos-offscreen-content-placeholder-text-left">
                      <div className="">
                        <div className="epilogos-offscreen-content-placeholder-table-container-item epilogos-offscreen-content-placeholder-table-container-item-contact">
                          <div className="epilogos-offscreen-content-placeholder-table-container-item-contact-logo">
                            <img src="assets/img/altius.svg" className="" alt="altius-logo" />
                          </div>
                          <div className="epilogos-offscreen-content-placeholder-table-container-item-contact-name">
                            <span className="epilogos-offscreen-content-placeholder-table-container-item-normal">Wouter Meuleman, PhD</span><br />
                            <span className="epilogos-offscreen-content-placeholder-table-container-item-light epilogos-offscreen-content-placeholder-table-container-item-normal">Investigator</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6} className="epilogos-offscreen-content-row-text-block epilogos-offscreen-content-row-text-block-contact" style={{"paddingLeft":"20px"}}>
                    <div className="epilogos-offscreen-content-placeholder-text-right">
                      <div className="">
                        <div className="epilogos-offscreen-content-placeholder-table-container-item epilogos-offscreen-content-placeholder-table-container-item-contact-details">
                          <span className="epilogos-offscreen-content-placeholder-table-container-item-normal">P</span> <span className="epilogos-offscreen-content-placeholder-table-container-item-light">206.267.1091</span><br />
                          <span className="epilogos-offscreen-content-placeholder-table-container-item-normal">E</span> <span className="epilogos-offscreen-content-placeholder-table-container-item-light"><a href="#0" onClick={this.onClick} data-id="mailto:meuleman(at)altius.org" data-target="_self">meuleman(at)altius.org</a></span><br /> 
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              
              </Container>
              
            </Nav>
          </Navbar>
          
        </div>
        
        <div className="job-designer-overlay" ref={(d) => {this.jobDesignerOverlay = d;}} id="job-designer-overlay">
          <div className="job-designer-overlay-content" ref={this.jobDesignerOverlayContent} style={this.state.jobDesignerOverlayContentStyle}>
            <img 
              alt="Job designer submit spinner"
              src={this.state.jobDesignerOverlayContentSpinnerSrc} 
              ref={this.jobDesignerOverlayContentSpinner} 
              className="spinner" 
              style={this.state.jobDesignerOverlayContentSpinnerStyle} />
            <div className="job-designer-overlay-content-msg" ref={this.jobDesignerOverlayContentMessage} dangerouslySetInnerHTML={{__html: this.state.overlayContent}}></div>
            <Button 
              id="jobDesignerOverlayOKButton"
              className="job-designer-overlay-ok-button btn-epilogos"
              ref={(elem)=>this.jobDesignerOverlayOKButton=elem}
              color="primary"
              size="sm"
              onClick={this.handleClick} 
              style={this.state.jobDesignerOverlayOKButtonStyle}
              name="closeOverlay">OK
            </Button>
          </div>
        </div>
        
        <div className="hidden-container">
          <img src="assets/img/spinner.svg" alt="spinner" className="spinner" />
        </div>
      </div>
    );
  }
  
}

export default Portal;
